import React from 'react'
import { IAddOnProgram, IEpiProps, IUserSelections } from '../models/event-reg-refresh-models'
import { useEventRegRefreshContext, useEventRegRefreshDispatch } from '../reducers/event-reg-refresh-reducers'
import { CardAccordion } from './card-accordion'

interface IContextProps {
  epiProps: IEpiProps
  userSelections: IUserSelections
}

type Props = {
  program: IAddOnProgram
  showPrice: boolean
  currency: string
  isSelected?: boolean
  onSelect?: () => void
  isReviewMode?: boolean
}

export const ProductBasedAddonCard = (props: Props) => {
  const { epiProps, userSelections }: IContextProps = useEventRegRefreshContext()!
  const dispatch = useEventRegRefreshDispatch()!
  const { program, isSelected, onSelect, showPrice, currency, isReviewMode } = props

  const selectButtonText = isSelected ? epiProps.selectedButtonText : epiProps.selectButtonText
  const priceValue = `$${program.programPrice.toLocaleString()}`
  const costPerAttendeeValueText = program.costPerAttendeeFormatText
    ? program.costPerAttendeeFormatText.replace('{0}', priceValue).replace('{1}', currency)
    : `${priceValue} ${currency}`

  const removeFromSelections = () => {
    const updatedSelections = (userSelections.userAddOnProgramSelections || []).filter(sel =>
      program.programSku && sel.programSku
        ? sel.programSku !== program.programSku
        : sel.programCode !== program.programCode
    )
    dispatch({
      type: 'updateUserSelections',
      data: {
        ...userSelections,
        userAddOnProgramSelections: updatedSelections,
      }
    })
  }

  if (isReviewMode) {
    return (
      <div className="card card-selected">
        <div className="card-dt-layout">
          <div className="card-dt-layout-content">
            <div>
              <h3 className="card-header-title">
                {program.productCardTitle || program.programName}
              </h3>
              {showPrice && (
                <div className="card-legend-item card-header-subtitle">
                  <span className="card-legend-item-icon card-dt-layout-legend-item-icon-price">
                    <svg className="svg-icon" aria-hidden="true" focusable="false">
                      <use xmlnsXlink="http://www.w3.org/2000/xlink" xlinkHref="#dollar-icon" />
                    </svg>
                  </span>
                  <p className="h6-style">
                    {costPerAttendeeValueText}{epiProps.costPerAttendeeLabelDateTimeCard}
                  </p>
                </div>
              )}
              <div className="card-legend-row">
                <div className="card-legend-item">
                  <span className="card-legend-item-icon">
                    <svg className="svg-icon" aria-hidden="true" focusable="false">
                      <use xmlnsXlink="ttp://www.w3.org/2000/xlink" xlinkHref="#icon-language" />
                    </svg>
                  </span>
                  <p className="h6-style">English</p>
                </div>
              </div>
            </div>

            <div className="card-dt-layout-actions-mobile">
              <button className="btn-primary btn-remove" onClick={removeFromSelections}>
                <span className="visually-hidden">Remove Addon</span>
                <svg className="svg-icon" aria-hidden="true" focusable="false">
                  <use xmlnsXlink="ttp://www.w3.org/2000/xlink" xlinkHref="#trash-icon" />
                </svg>
              </button>
            </div>

            <div>
              {epiProps.productBasedCardTitleFormat && program.programSku && (
                <p className="card-dt-layout-address">
                  {epiProps.productBasedCardTitleFormat.replace('{sku}', program.programSku)}
                </p>
              )}
            </div>
          </div>
          <div className="card-dt-layout-actions">
            <button className="btn-primary btn-remove" onClick={removeFromSelections}>
              <span className="visually-hidden">Remove Addon</span>
              <svg className="svg-icon" aria-hidden="true" focusable="false">
                <use xmlnsXlink="ttp://www.w3.org/2000/xlink" xlinkHref="#trash-icon" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className={`card ${isSelected ? 'card-selected' : ''}`}>
      <div className="card-header">
        {program.imageUrl && program.imageUrl.length > 0 && (
          <img className="card-header-image" src={program.imageUrl} alt={program.programImageAlternateText} />
        )}
        <div className="card-header-content">
          <h3 className="card-header-title">{program.programName}</h3>
          {showPrice && (
            <div className="card-legend-item">
              <span className="card-legend-item-icon">
                <svg className="svg-icon" aria-hidden="true" focusable="false">
                  <use xmlnsXlink="ttp://www.w3.org/2000/xlink" xlinkHref="#dollar-icon" />
                </svg>
              </span>
              <p className="h6-style app-sort">
                {costPerAttendeeValueText}
              </p>
            </div>
          )}
        </div>
        {onSelect && (
          <div className="card-header-actions">
            <button className="btn-primary card-action-button" onClick={onSelect}>
              {selectButtonText}
              {isSelected && (
                <svg className="svg-icon" aria-hidden="true" focusable="false">
                  <use xmlnsXlink="ttp://www.w3.org/2000/xlink" xlinkHref="#icon-checkmark" />
                </svg>
              )}
            </button>
          </div>
        )}
      </div>

      {program.programChips && program.programChips.length > 0 && (
        <div className="card-chip-container">
          {program.programChips.map((chip) => (
            <span key={chip} className="card-chip-item">{chip}</span>
          ))}
        </div>
      )}

      {program.programDetails && (
        <div dangerouslySetInnerHTML={{ __html: program.programDetails }} />
      )}

      {program.detailsDescription && (
        <div className="card-addon-details">
          <CardAccordion title={epiProps.addOnDetailsHeaderText} includeSnippet>
            <div className="rich-text" dangerouslySetInnerHTML={{ __html: program.detailsDescription }} />
          </CardAccordion>
        </div>
      )}
    </div>
  )
}
